import { render, staticRenderFns } from "./DeleteRequestReview.vue?vue&type=template&id=1c1d8788"
import script from "./DeleteRequestReview.vue?vue&type=script&lang=js"
export * from "./DeleteRequestReview.vue?vue&type=script&lang=js"
import style0 from "./DeleteRequestReview.vue?vue&type=style&index=0&id=1c1d8788&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports